<script setup>
import { signOut } from '@/API/auth'
import { clearAuthToken } from '@/services/auth'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { useEventsStore } from '@/store/events'
import { useProfileStore } from '@/store/profile'
import AccountIcon from '@/components/icons/AccountIcon.vue'
import LogoutIcon from '@/components/icons/LogoutIcon.vue'

const router = useRouter()
const authStore = useAuthStore()
const eventsStore = useEventsStore()
const profileStore = useProfileStore()

const goToAccountSettings = () => {
  router.push({ name: 'settings' })
}

const submitLogout = () => {
  return signOut()
    .then(() => {
      clearAuthToken()

      authStore.$reset()
      eventsStore.$reset()
      profileStore.$reset()

      router.push({
        name: 'login',
      })
    })
    .catch(() => {
      //TODO: Log error to Sentry
    })
}

const items = [
  {
    title: 'Account Settings',
    label: 'Navigate to account settings',
    icon: AccountIcon,
    onClick: () => goToAccountSettings(),
  },
  {
    title: 'Sign Out',
    label: 'Sign out',
    icon: LogoutIcon,
    onClick: () => submitLogout(),
  },
]
</script>

<template>
  <v-btn
    variant="outlined"
    size="large"
    append-icon="custom:ArrowDownIcon"
    aria-label="Account dropdown menu"
    class="profile-chip__chip v-btn__light"
  >
    <p class="d-none d-lg-block">{{ authStore.email }}</p>
    <v-icon class="d-lg-none" icon="custom:AccountIcon" />

    <v-menu activator="parent">
      <v-list class="profile-chip__menu">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :value="index"
          :aria-label="item.label"
          @click="item.onClick"
          class="profile-chip__menu-item"
        >
          <v-list-item-title class="profile-chip__menu-title body-text">
            <component :is="item.icon" />
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-btn>
</template>

<style scoped>
.profile-chip__chip {
  border: 2px solid #3f3f3f;
  border-radius: 99999px !important;
  text-transform: lowercase;

  font-size: 16px;
  font-style: normal;
  line-height: 22px; /* 137.5% */
}

.profile-chip__menu {
  margin-top: 10px;
  border-radius: 12px !important;
  box-shadow: 0px 4px 12px 0px #00000014 !important;
  box-shadow: 0px 2px 4px 0px #0000000d !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  color: #333759;

  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 137.5% */
}

.profile-chip__menu-item :deep(.v-list-item-title) {
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 28px !important;
}

.profile-chip__menu-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 175% */
}
</style>
